export const intial_state ={

    width: 30,
    min: 0,
    max: 100,
    _imageHeight:80,

    _showControls: false,
    _showWidth: false,

    _before: "",

    _errorImage:"",


    image_status: "initial",
    loaded: false,
    before_error: false,
    after_error: false,
    before_loaded: false,
    after_loaded: false,

}